import React from 'react'
import './ConstructionChemicals.scss'
import SupplementaryServices from '../components/SupplementaryServices'

const TextileChemical = () => {

    let mapData = {
        title: "Textile <span> Chemicals</span>",
        desc: "Hutaib Industrial Solutions offers a broad spectrum of top-tier chemicals, developed to meet the dynamic needs of multiple industries.",
        mapItem: [
            {
                title: 'Amino Functional Fluids',
                description: 'These silicone-based fluids enhance softness, elasticity, and smoothness in fabrics, making them ideal for premium textile finishes.',
                slug: 'momentive-amino-functional-fluid',
                localImage: '/assets/images/aminoFunctional.webp'
            }, {
                title: 'Block Silicone Fluids',
                description: 'Designed for durable softness and excellent surface smoothness, block silicone fluids offer improved washing durability and compatibility in textile processing.',
                slug: 'silicone-oil',
                localImage: '/assets/images/blockSiliconeFluid.webp'
            }, {
                title: 'Hydrophilic',
                description: 'These finishes allow fabrics to absorb and wick moisture effectively, enhancing comfort, especially in sportswear and activewear.',
                slug: 'hydrophilic-oil',
                localImage: '/assets/images/hydrocloric.webp'
            }, {
                title: 'PDMS Emulsion',
                description: 'A high-performance silicone emulsion that imparts a silky, smooth touch to textiles while boosting fabric strength and flexibility.',
                slug: 'polydimethylsiloxane',
                localImage: '/assets/images/Polydimethylsiloxane.webp'
            }, {
                title: 'Softener',
                description: 'Our textile softeners reduce fabric stiffness, improve drape, and deliver a pleasant hand feel, suitable for a wide range of fabric types.',
                slug: 'softeners-for-textile',
                localImage: '/assets/images/Softener.webp'
            },
        ]
    }

    return (
        <div className='Wrapme'>
            <SupplementaryServices data={mapData} />
        </div>
    )
}

export default TextileChemical